import React, { useState, useEffect } from "react";
import { getNewsletters } from "services/restAPI/RestApi";
import { Table } from "antd";
import {
   setTemplateSubscribers,
   setTemplateNewsletter,
   setNewsletterContent,
   setIsFileAdded
} from "appRedux/actions/Newsletter";
import { useDispatch, useSelector } from "react-redux";
import selectAntdRow from "@util/Scripts";
import "./steps.less";
import "./csvupload.css";
import IntlMessages from "@util/IntlMessages";
import { getList } from "../../../services/api/Api.js";
import { isCarlsbergUser } from "../../../util/Scripts";
import { Spin, Card } from "../../BP2Components";
import projectConfig from "@projectConfig";
import { setNewsletterCsv } from "../../../appRedux/actions/Newsletter";

export const getLabelFromTechName = (techName, columns) => {
   return columns?.find((column) => column?.options?.techName == techName)?.label;
};

const ThirdStep = (props) => {
   const dispatch = useDispatch();

   const [tableData, setTableData] = useState({
      selectedRowKeys: [],
      totalItems: 0,
      totalPages: 1,
      page: 1,
      name: "",
      columns: [{ title: "Newsletter", dataIndex: "name", key: "name" }],
      dataSource: []
   });
   const authUser = useSelector(({ auth }) => auth.authUser);
   const { templateSubscribers } = useSelector(({ newsletter }) => newsletter);

   // Subscribers list
   const [subsData, setSubsData] = useState(() => {
      return {
         selectedRowKeys: [],
         totalItems: 0,
         totalPages: 1,
         page: 1,
         name: "",
         columns: /* isCarlsbergUser(authUser) temp fix cp*/ true
            ? [
                 {
                    title: "Email",
                    dataIndex: "email",
                    key: "email",
                    sortDirections: ["descend", "ascend"],
                    sorter: (a, b) => a.email - b.email
                 }
              ]
            : [
                 {
                    title: "Name",
                    dataIndex: "clientName",
                    key: "clientName",
                    sortDirections: ["descend", "ascend"],
                    sorter: (a, b) => a.name - b.name
                 },
                 {
                    title: "Email",
                    dataIndex: "email",
                    key: "email",
                    sortDirections: ["descend", "ascend"],
                    sorter: (a, b) => a.email - b.email
                 }
              ],
         dataSource: []
      };
   });
   const handleListResponse = (templateNewsletter, newsletterContent, data) => {
      dispatch(setTemplateNewsletter(templateNewsletter));
      const newTemplateSubscribers = [...templateSubscribers];
      newTemplateSubscribers.map((sub) => (sub.checked = false));
      dispatch(setNewsletterContent(newsletterContent));
      dispatch(setTemplateSubscribers(newTemplateSubscribers));

      setTableData({
         ...tableData,
         totalItems: data.length,
         dataSource: data
      });

      if (data && data.length > 0) {
         rowClickHandler(data[0].subscribents);
      }
      selectAntdRow("newsletters", 0);
   };

   useEffect(() => {
      if (/* isCarlsbergUser(authUser)  temp fix cp*/ true) {
         getNewsletters().then((res) => {
            const templateNewsletter = {
               name: res.data[0].name,
               id: res.data[0].id
            };

            const newsletterContent = {
               wId: props.id,
               newsletterName: res.data[0].name,
               newsletterId: res.data[0].id
            };

            const data = res.data.map((row) => {
               return {
                  id: row.id,
                  key: row.id,
                  name: row.name,
                  template: row.template,
                  subscribents: row.subscribents
               };
            });

            handleListResponse(templateNewsletter, newsletterContent, data);
         });
      } else {
         getList(projectConfig?.newsletterMailsList, 1, 700).then((res) => {
            const templateNewsletter = {
               name: res.data.default.meta.name,
               id: 1
            };
            const newsletterContent = {
               newsletterName: templateNewsletter.name,
               newsletterId: templateNewsletter.id,
               wId: props.id
            };
            const data = [
               {
                  id: 1,
                  key: 1,
                  name: newsletterContent.newsletterName,
                  subscribents: [
                     ...res.data.default.data.map((row) => ({
                        id: row[
                           getLabelFromTechName("Klient_kli_id_74iq4t", res.data.default.columns)
                        ],
                        recipent: {
                           email: row[
                              getLabelFromTechName(
                                 "Klient_kli_email_7ofer6",
                                 res.data.default.columns
                              )
                           ],
                           firstName:
                              row[
                                 getLabelFromTechName(
                                    "Klient_kli_nazwa_285l6a",
                                    res.data.default.columns
                                 )
                              ],
                           companies: null
                        }
                     }))
                  ]
               }
            ];
            handleListResponse(templateNewsletter, newsletterContent, data);
         });
      }
      // eslint-disable-next-line
   }, []);
   const rowClickHandler = (subscribents, record, i) => {
      if (subscribents) {
         selectAntdRow("newsletters", i);
         if (record) {
            dispatch(setTemplateNewsletter({ name: record.name, id: record.id }));
            dispatch(
               setNewsletterContent({
                  wId: props.id,
                  newsletterName: record.name,
                  newsletterId: record.id
               })
            );
         }
         const data = subscribents.map((sub) => {
            return {
               id: sub.id,
               key: sub.id,
               clientName: sub.recipent.firstName,
               email: sub.recipent.email,
               nip: sub.recipent.companies ? sub.recipent.companies[0].nip : "-",
               checked: false
            };
         });
         setSubsData({
            ...subsData,
            totalItems: data.length,
            dataSource: data
         });
      }
   };
   const subsRowClickHandler = (row, ev) => {
      row.checked = ev.target.checked;
      dispatch(setTemplateSubscribers(subsData.dataSource));
      dispatch(
         setNewsletterContent({
            wId: props.id,
            subscribers: subsData.dataSource
         })
      );
   };
   const allHandler = (selected) => {
      if (selected === true) {
         subsData.dataSource.forEach((sub) => {
            sub.checked = true;
         });
      } else {
         subsData.dataSource.forEach((sub) => {
            sub.checked = false;
         });
      }
      dispatch(setTemplateSubscribers(subsData.dataSource));
      dispatch(
         setNewsletterContent({
            wId: props.id,
            subscribers: subsData.dataSource
         })
      );
   };

   const onFileUpload = (e) => {
      let csvFile = e.target.files[0];
      let formData = new FormData();
      formData.append("file", csvFile);
      dispatch(
         setNewsletterContent({
            wId: props.id,
            csv: formData
         })
      );
      dispatch(setIsFileAdded(true));
      // i added this dispatch here, becouse formData created here, and then joined with other formData does not work (java have problem with the request body)
      // so we provide simple csv file, and then before puting it into request, we convert it to the formData
      dispatch(setNewsletterCsv(csvFile));
   };

   return (
      <>
         <div className="third-step-container">
            <div>
               <Card>
                  <IntlMessages id="w.newsletter.chooseNewsletter" />
               </Card>
               {tableData.totalItems !== 0 ? (
                  <>
                     <div className="custom-widget">
                        <Table
                           rowKey={(record) => record.ID}
                           className="gx-table-responsive newsletter-list newsletters"
                           components={tableData.component}
                           columns={tableData.columns}
                           dataSource={tableData.dataSource}
                           pagination={false}
                           size="medium"
                           bordered
                           onRow={(record, i) => {
                              return {
                                 onClick: (e) => rowClickHandler(record.subscribents, record, i)
                              };
                           }}
                        />
                     </div>
                  </>
               ) : (
                  <Card className="gx-card">
                     <Spin className="gx-loader-container" />
                  </Card>
               )}
            </div>
            <div style={{ overflow: "auto" }}>
               <Card>
                  {" "}
                  <IntlMessages id="w.newsletter.chooseSubs" />{" "}
               </Card>
               <div className="custom-widget">
                  <div className="maxHScroll">
                     <Table
                        rowKey={(record) => record.ID}
                        className="gx-table-responsive newsletter-list"
                        components={subsData.component}
                        columns={subsData.columns}
                        dataSource={subsData.dataSource}
                        pagination={false}
                        size="medium"
                        bordered
                        onRow={(record) => {
                           return {
                              onChange: (ev) => subsRowClickHandler(record, ev)
                           };
                        }}
                        rowSelection={{
                           onSelectAll: (selected) => allHandler(selected)
                        }}
                     />
                  </div>
               </div>
            </div>
            <div className="upload-div">
               <span className="csv-container">
                  <form id="custom-form" encType="multipart/form-data">
                     <input
                        type="file"
                        id="myfile"
                        className="csv-input"
                        name="myfile"
                        onChange={onFileUpload}
                     ></input>
                  </form>
               </span>
            </div>
         </div>
      </>
   );
};

export default ThirdStep;
